import { Component, OnInit, Input } from '@angular/core';
import QRCode from 'qrcode';
import { ModalController, ToastController, LoadingController } from '@ionic/angular';
import { AuthService } from "src/app/services/auth.service";
import { Storage } from "@ionic/storage";
import { AppStorageKey } from "src/app/static";

@Component({
  selector: 'app-qr-access',
  templateUrl: './qr-access.component.html',
  styleUrls: ['./qr-access.component.scss'],
})
export class QrAccessComponent implements OnInit {

  @Input() data: any;

  qrCode: string;

  timeinterval: any;

  constructor(
    public modalController : ModalController,
    private storage: Storage,
    public authService: AuthService,
    public toastCtrl: ToastController,
    private loadingController: LoadingController
  ) { }

  async ngOnInit() {
    this.getQRImage();
  }

  async getQRImage(){
    let CurrentDate = new Date();
    let qrCodeData = await this.storage.get(AppStorageKey.QrCode);
    if(qrCodeData){
      let qrDate = new Date(qrCodeData.fechaVencimiento);
      if(CurrentDate > qrDate){
        this.presentLoading();
        const response: any = await this.authService.getQrImage().toPromise();
        this.loadingController.dismiss();
        if(typeof response['code'] !== 'undefined'){
          this.generateQrCode(response.data);
          let expirationDate = new Date();
          this.addSeconds(expirationDate,30);
          this.initializeClock('clockdiv', expirationDate.toString());
          this.saveQrCode({
            fechaVencimiento: this.formatDate(expirationDate)
          });
        }else if(typeof response['status'] !== 'undefined' && response['status'] == 500){
          this.presentToast(response['errorMessage']);
        }
      }else{
        this.initializeClock('clockdiv', qrDate.toString());
        this.qrCode = qrCodeData.image;
      }
    }else{
      this.presentLoading();
      const response: any = await this.authService.getQrImage().toPromise();
      this.loadingController.dismiss();
      if(typeof response['code'] !== 'undefined'){
        this.generateQrCode(response.data);
        let expirationDate = new Date();
        this.addSeconds(expirationDate,30);
        this.initializeClock('clockdiv', expirationDate.toString());
        this.saveQrCode({
          fechaVencimiento: this.formatDate(expirationDate)
        });
      }else if(typeof response['status'] !== 'undefined' && response['status'] == 500){
        this.presentToast(response['errorMessage']);
      }
      
    }
  }

  async presentLoading() {
    let loading = await this.loadingController.create({
      message: "Porfavor espera...",
    });
    await loading.present();
  }

  addSeconds(date, seconds) {
    date.setSeconds(date.getSeconds() + seconds); // Set the seconds to current seconds + 30
    return date;
  }

  generateQrCode(data){
    QRCode.toDataURL(data, { width: 265 }, (err, url) => {
      if (err) {
        console.error(err);
        return;
      }
      this.qrCode = url; // URL del código QR generado
    });
  }

  async regenerateQrCode(){
    const response: any = await this.authService.getQrImage().toPromise();
    if(typeof response['code'] !== 'undefined'){
      this.generateQrCode(response.data);
      clearInterval(this.timeinterval);
      let expirationDate = new Date();
      this.addSeconds(expirationDate,30);
      this.initializeClock('clockdiv', expirationDate.toString());
      let data = {
        fechaVencimiento: this.formatDate(expirationDate)
      };
      this.saveQrCode(data);
    }else if(typeof response['status'] !== 'undefined' && response['status'] == 500){
      this.presentToast(response['errorMessage']);
    }
  }

  // Presenta el toast con el error
  async presentToast(msg) {
    const toast = await this.toastCtrl.create({
      message: msg,
      duration: 5000,
      position: 'top',
      color: 'danger',
      cssClass: 'toast',
    });
    toast.present();
  }

  padTwoDigits(num: number) {
    return num.toString().padStart(2, "0");
  }
  
  formatDate(date: Date, dateDiveder: string = "-") {
    return (
      [
        date.getFullYear(),
        this.padTwoDigits(date.getMonth() + 1),
        this.padTwoDigits(date.getDate()),
      ].join(dateDiveder) +
      " " +
      [
        this.padTwoDigits(date.getHours()),
        this.padTwoDigits(date.getMinutes()),
        this.padTwoDigits(date.getSeconds()),
      ].join(":")
    );
  }

  saveQrCode(qrData){
    this.storage.set(AppStorageKey.QrCode,{ ...qrData, image: this.qrCode });
  }

  closeModal(){
    this.modalController.dismiss();
    clearInterval(this.timeinterval);
  }

  initializeClock(id, endtime) {
    const clock = document.getElementById(id);
    const secondsSpan = clock.querySelector('.seconds');
    const self = this;
  
    function updateClock(checkTimer = true) {
      const t = self.getTimeRemaining(endtime);
      secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
      if (t.total <= 0 && checkTimer) {
        clearInterval(self.timeinterval);
        self.regenerateQrCode();
      }
    }

    updateClock(false);
    this.timeinterval = setInterval(updateClock, 1000);
  }

  getTimeRemaining(endtime){
    const total = Date.parse(endtime) - Date.parse(new Date().toString());
    const seconds = Math.floor( (total/1000) % 60 );
    return {
      total,
      seconds
    };
  }
}
